<template>
    <a-modal :title="title" width="900px" :maskClosable="false" :visible.sync="show" @cancel="() => $emit('update:show', false)" :footer="null" :getContainer="() => $parent.$el">
        <div v-if="detail.id">
            <a-alert :show-icon="false" banner>
                <div slot="message">{{ detail.name }} [ {{ detail.type | raceType }} / {{ (detail.type + '_' + detail.level) | raceLevel }} ] 共 {{ detail.uds.length }} 人参赛</div>
            </a-alert>

            <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="detail.uds" bordered :pagination="false">
                <a-table-column key="sno" ellipsis>
                    <span slot="title">参赛设备</span>
                    <template slot-scope="text, record">
                        <span>[{{ record.sno }}] {{ record.dname }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="name" ellipsis>
                    <span slot="title">参赛人员</span>
                    <template slot-scope="text, record">
                        <span>{{ record.name }} / {{ record.gender === 'M' ? '男' : '女' }} / {{ record.age }} 周岁</span>
                    </template>
                </a-table-column>
                <a-table-column key="qual" ellipsis width="100px">
                    <span slot="title">完成质量</span>
                    <template slot-scope="text, record">
                        <span>{{ record.qual || '无数据' }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="result" ellipsis width="100px">
                    <span slot="title">比赛成绩</span>
                    <template slot-scope="text, record">
                        <span>{{ record.result || '无数据' }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="rank" ellipsis width="80px">
                    <span slot="title">名次</span>
                    <template slot-scope="text, record">
                        <span v-if="record.rank > 0">{{ record.rank }}</span>
                        <span v-else>无名次</span>
                    </template>
                </a-table-column>
            </a-table>
        </div>
    </a-modal>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    filters: {
        raceType: value => {
            switch (value) {
                case 'R01':
                    return '注意力猜拳'
                case 'R02':
                    return '舒尔特方格'
                case 'R03':
                    return '虚实线'
                case 'R04':
                    return '中心悬点'
            }
        },
        raceLevel: value => {
            switch (value) {
                case 'R01_Easy':
                    return '简单（限时 2 秒）'
                case 'R01_Normal':
                    return '普通（限时 1.5 秒）'
                case 'R01_Hard':
                    return '困难（限时 1 秒）'
                case 'R02_Easy':
                    return '简单（3*3 方格）'
                case 'R02_Normal':
                    return '普通（4*4 方格）'
                case 'R02_Hard':
                    return '困难（5*5 方格）'
                case 'R03_Easy':
                    return '简单（1 行 2 图）'
                case 'R03_Normal':
                    return '标准（2 行 4 图）'
                case 'R03_Hard':
                    return '困难（2 行 6 图）'
                case 'R04_Easy':
                    return '简单（4 行 6 列）'
                case 'R04_Normal':
                    return '标准（5 行 8 列）'
                case 'R04_Hard':
                    return '困难（6 行 10 列）'
            }
        }
    },
    data() {
        return {
            detail: {
                uds: []
            }
        }
    },
    mounted() {
        this.$http
            .get('/cts/ate/race/mgr/detail', {
                params: {
                    id: this.item.id
                },
                loading: {
                    full: false
                }
            })
            .then(result => {
                this.detail = result.data
            })
    }
}
</script>
